import { defaultDataGridProps } from '@cw-ui/data-grid';
import { getGridStringOperators, getGridNumericOperators, getGridSingleSelectOperators } from '@mui/x-data-grid-pro';

export const CORPORATE_STRUCTURE = 'corporate-structure';

export const RESOURCES_TYPES = {
    CONTAINER: 'container',
    COMPANY: 'company',
    SITE: 'site',
    DEVICE: 'device',
};

export const assignAllFutureCompaniesName = 'All + Future Companies';
export const assignAllFutureSitesName = 'All + Future Sites';

export const universityLink = 'https://university.connectwise.com/';

export const companyLink =
    'https://docs.connectwise.com/ConnectWise_RMM/Client_Management/Companies_and_Sites#Add_Company';

export const siteLink =
    'https://docs.connectwise.com/ConnectWise_RMM/Client_Management/Companies_and_Sites#Create_a_Site';

export const universityLinkAssignResource =
    'https://docs.connectwise.com/ConnectWise_Unified_Product/ConnectWise_Home/040/Users_Tab/Assign_Resource_Access_for_Asio_Platform_Users';

export const DEFAULT_PAGE_SIZE = 50;

export const DATA_GRID_DEFAULTS = {
    ...defaultDataGridProps,
    pageSizeOptions: [50, 100, 250, 500],
    disableRowSelectionOnClick: true,
    paginationMode: 'server',
    keepNonExistentRowsSelected: true,
    filterMode: 'server',
    sx: {
        '& .toolbar': {
            margin: '0 0 8px 0',
        },
    },
};

export const textFilterOptions = ['contains', 'equals'];
export const statusFilterOptions = ['is'];
export const numbericFilterOptions = ['<', '>', '=', '<=', '>='];

export const getTextFilterOperators = getGridStringOperators().filter(item => textFilterOptions.includes(item.value));
export const getStatusFilterOperators = getGridSingleSelectOperators().filter(item =>
    statusFilterOptions.includes(item.value)
);
export const getNumericFilterOperators = getGridNumericOperators().filter(item =>
    numbericFilterOptions.includes(item.value)
);
